module.exports = __webpack_public_path__ + "125a1a17cf355e0224d288ddd12ac4bc.MP3";